<template>
  <div class="BuyerListListContainer">
    <nut-row class="bothCenter wbg">
      <span class="ft12 lightText">当前仅展示最近20单</span>
    </nut-row>
    <template v-for="(od,i) in orders" :key="`p${od.id}`">
      <BuyerItem :data="{
        avatar:od.buyerAvatar,
        name:od.buyerName,
        time:od.paidTime,
        index:i+1,
      }"/>
    </template>
  </div>
</template>

<script>
import BuyerItem from "@/components/sale/BuyerItem";
export default {
  name: "BuyerList",
  components: {BuyerItem},
  props: {
    orders: {
      type: Array,
      default: ()=>{
        return []
      }
    },
  },
  data() {
    return {

    }
  },
  methods: {
    init() {

    }
  },
  mounted() {
    this.init()
  }
}
</script>

<style lang="scss" scoped>
.BuyerListContainer {
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 16px;
}
</style>